<template>
  <picture>
    <source :srcset="imageUrl" type="image/webp" />
    <img :src="src" :alt="alt" :width="width" :height="height" :class="class" />
  </picture>
</template>
<script setup lang="ts">
import { IMAGE_QUALITY } from '~/utils/const';

type Props = {
  src: string | undefined;
  format: 'webp' | 'jpeg' | 'png';
  sourceType: 'articleList' | 'articleDetail';
  isPc: boolean;
  class: string;
  alt?: string;
  width?: number;
  height?: number;
};

const imageUrl = computed(() => {
  const params = new URLSearchParams();
  const quality = props.isPc
    ? IMAGE_QUALITY[props.sourceType].pc
    : IMAGE_QUALITY[props.sourceType].sp;
  params.append('fm', props.format);
  params.append('q', quality);

  if (props.width) params.append('w', props.width.toString());
  if (props.height) params.append('h', props.height.toString());

  return `${props.src}?${params.toString()}`;
});

const props = withDefaults(defineProps<Props>(), {});
</script>
